export default __webpack_public_path__ + "static/media/robotics-logo.1e82fe34.png";